import styled from "styled-components";

export const CvActionsFooterWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;

  button {
    margin: 0 2.5px;
  }
`;

export const DownloadCvButton = styled.button`
  font-weight: bold;
  color: #79D9D9;
  background: transparent;
  border: 1px solid #79D9D9;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 22px;
  text-rendering: optimizeLegibility;
  padding: 10px 12px;
  font-family: Komet;
  text-align: center;
  letter-spacing: 0.03em;
  text-transform: capitalize;
  font-size: 1em;
  min-width: 100px;
  transition: 0.15s ease-in-out;

  &:hover {
    cursor: pointer;
    color: "#fff";
    background: "#79D9D9";
    border: 1px solid #79D9D9;
  }

  &:active,
  &:visited {
    cursor: pointer;
    color: #fff;
    background: #402680;
    border: 1px solid #402680;
    outline: none;
  }

  &[disabled] {
    border: 1px solid grey;
    background: transparent;
    color: grey;
    cursor: no-drop;
  }

  &:focus {
    background: "#402680";
    border: "1px solid #402680";
    outline: none;
  }
`;
